import styled from "styled-components";
import {
  GoldContainer,
  MainContainer,
  FlexContainer,
  TextContainer,
} from "./containers";
import { GoldButton } from "../../components/GoldButton";
import { IconRows, IconCt, IconText } from "./iconText";
import { useMainDescriptionsQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
const Title = styled(TextContainer)`
  align-self: flex-start;
  padding-bottom: 60px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  p {
    max-width: 500px;
    padding: 60px 0;
    text-align: justify;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    p {
      padding: 20px 0;
    }
  }
`;

const RightContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  gap: 20px;
  flex: 1;
  img {
    max-width: 350px;
    height: auto;
    z-index: 1;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
`;
const Icons = styled.div`
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function EventiAziende() {
  const lang = localStorage.getItem("lang");
  const { data } = useMainDescriptionsQuery({
    variables: { id: "3Jr4Wma5ymCU4KQvATMjXV" },
  });
  return (
    <FlexContainer $bgColor='white' $color='black'>
      <MainContainer>
        <Title>
          <h1>{data?.descrizionePrincipale?.titolo}</h1>
        </Title>

        <GoldContainer>
          <Container>
            <TextContainer>
              {documentToReactComponents(
                data?.descrizionePrincipale?.descrizione?.json
              )}
            </TextContainer>
            <RightContainer>
              <img src='event/aziende.webp' />
            </RightContainer>
          </Container>
          <Icons>
            {lang !== "it" ?
              <IconRows>
                <IconCt>
                  <IconText text='Padel tournament' icon='Padel' />
                  <IconText text='Clinic with coach' icon='Padel' />
                  <IconText text='Functional training' icon='Padel' />
                  <IconText text='Padel experience' icon='Padel' />
                </IconCt>
                <IconCt>
                  <IconText text='Welcome coffee' icon='cafe' />
                  <IconText text='Coffee break' icon='cafe' />
                  <IconText text='Aperitif' icon='glass' />
                  <IconText text='Cocktail experience' icon='Padel' />
                </IconCt>
                <IconCt>
                  <IconText text='Lunch & Dinner' icon='fork' />
                  <IconText text='Meeting room' icon='Table' />
                  <IconText text='Pool Party' icon='pool' />
                  <IconText text='Hotel lodging' icon='star' />
                  <IconText text='Breakfast' icon='sweet' />
                </IconCt>
              </IconRows>
            : <IconRows>
                <IconCt>
                  <IconText text='Torneo di padel' icon='Padel' />
                  <IconText text='Clinic con maestro' icon='Padel' />
                  <IconText text='Allenamento funzionale' icon='Padel' />
                  <IconText text='Padel experience' icon='Padel' />
                </IconCt>
                <IconCt>
                  <IconText text='Welcome coffee' icon='cafe' />
                  <IconText text='Coffee break' icon='cafe' />
                  <IconText text='Aperitivo' icon='glass' />
                  <IconText text='Cocktail experience' icon='Padel' />
                </IconCt>
                <IconCt>
                  <IconText text='Pranzo e Cena' icon='fork' />
                  <IconText text='Sala meeting' icon='Table' />
                  <IconText text='Pool Party' icon='pool' />
                  <IconText text='Pernottamento in hotel' icon='star' />
                  <IconText text='Breakfast' icon='sweet' />
                </IconCt>
              </IconRows>
            }
          </Icons>
        </GoldContainer>
        <GoldButton style={{ marginTop: 50 }}>RICHIEDI INFORMAZIONI</GoldButton>
      </MainContainer>
    </FlexContainer>
  );
}
